<template>
    <div class="contentTrackList-container">
        <headline @reload="page.pageIndex = 1;getList()" :params="headLines" />
        <div class="content-container">
            <div class="header">
                <img src="../../assets/img/analysis/trackList.png" alt="">
                <div class="info">
                    <p>跟踪自定义文稿，了解传播效果</p>
                    <div @click="navigate('contentTrack', true)" class="btn">
                        <i></i>
                        点击开始检索
                    </div>
                </div>
            </div>

            <div class="filterBtn">
                <div class="left">历史查询记录</div>
                <div class="right">
                    <div @click="page.pageIndex = 1;getList()" class="btn on">刷新</div>
                    <div @click="clear" class="btn">清空记录</div>
                </div>
            </div>

            <div class="list-container">
                <empty v-if="list.length == 0" :msg="'暂无查询记录'"></empty>
                <ul v-if="list.length > 0">
                    <li @click="To(item.id, true, item.status)" v-for="item in list" :key="item.id">
                        <div class="title">
                            <div class="left">{{item.title}}</div>
                            <div v-if="item.status != 1" class="right">{{item.status_name}}</div>
                        </div>
                        <div class="content">{{item.content}}</div>
                        <div class="time">
                            <i></i>
                            {{item.time}}
                        </div>
                    </li>
                </ul>

                <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
            </div>
        </div>
    </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import { apis } from '@common/config'
import headline from "@components/headline";
import empty from "@components/empty";

export default {
    components: {
        headline,pages,empty
    },
    data() {
        return {
            list: [],
            headLines: {
                title: "",
                showLink: false,
                filter: false
            },
            page: {
                pageCount: 0,
                pageIndex: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    methods: {
        To(id, isNew = false, status){
            if(status == 1){
                common.jump('/contentTrackDetail?d='+id, false)
            }
        },
        navigate(url, isNew = false) {
            common.jump(url, isNew)
        },
        getList() {
            let info = {    
                page: this.page.pageIndex,
                pagesize: this.page.pageSize
            }

            common.myFetch(apis.tracklist, info).then(res => {
                console.log(res)
                this.list = res.list
                this.$set(
                    this.page,
                    "pageCount",
                    common.calculatePage(res.page.row_count - 0, this.page.pageSize)
                );
                this.$set(this.page, "total", res.page.row_count - 0);
            })
        },
        clear() {
            common.myFetch(apis.tracklistclear).then(res => {
                if(res) {
                    this.page.pageIndex = 1;
                    this.getList()
                }
            })
        }
    },
    created() {
        this.headLines.title = '文稿追踪'
        this.getList()
    }
}
</script>

<style lang="less" scoped>
    .contentTrackList-container {
        display: flex;
        flex-direction: column;

         .content-container {
             display: flex;
             flex-direction: column;
             width: 1064px;
             margin: 0 auto;
             padding-top: 30px;
             box-sizing: border-box;
             margin-bottom: 50px;

             .header {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                height: 144px;
                background: #FFFFFF;
                padding: 0 12px;
                box-sizing: border-box;
                margin-bottom: 20px;

                img {
                    width: 470px;
                    height: 144px;
                    margin-right: 66px;
                }

                .info {
                    display: flex;
                    flex-direction: column;

                    p {
                        position: relative;
                        font-size: 27px;
                        line-height: 38px;
                        font-weight: 500;
                        color: #050F0F;
                        z-index: 1;

                        &::after {
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            z-index: -1;
                            display: block;
                            content: '';
                            width: 130px;
                            height: 10px;
                            background: #65DEB4;
                            border-radius: 2px;
                        }
                    }

                    .btn {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        width: 148px;
                        height: 40px;
                        background: #41B48C;
                        border-radius: 20px;
                        user-select: none;
                        cursor: pointer;
                        font-size: 14px;
                        line-height: 20px;
                        font-weight: bold;
                        color: #FFFFFF;
                        margin-top: 14px;

                        i {
                            display: block;
                            width: 15px;
                            height: 15px;
                            background: url('../../assets/img/analysis/whiteSearch.png') no-repeat;
                            background-size: 100% 100%;
                            background-position: center center;
                            margin-right: 8px;
                        }

                    }
                }

             }

             .filterBtn {
                 display: flex;
                 flex-direction: row;
                 align-items: center;
                 justify-content: space-between;
                 margin-bottom: 20px;

                 .left {
                     font-size: 14px;
                     line-height: 20px;
                     color: #050F0F;
                     font-weight: bold;
                 }

                 .right {
                     display: flex;
                     flex-direction: row;
                     align-items: center;

                     .btn {
                         width: 100px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        background: #FFFFFF;
                        border-radius: 4px;
                        color: #829191;
                        font-size: 14px;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            width: 59px;
                            height: 30px;
                            background: #FFFFFF;
                            border-radius: 4px;
                            color: #41B48C;
                            margin-right: 10px;
                        }
                     }
                 }
             }

             .list-container {
                display: flex;
                flex-direction: column;
                width: 100%;
                background: #F9F9F9;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;
                padding-bottom: 50px;
                box-sizing: border-box;

                ul {
                    display: flex;
                    flex-direction: column;

                    li {
                        padding: 28px 30px;
                        box-sizing: border-box;

                        &:hover {
                            background: rgba(185, 195, 195, 0.15);

                            .title {
                                .left {
                                    color: #41B48C;
                                }
                            }
                        }

                        .title {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;

                            .left {
                                font-size: 18px;
                                line-height: 25px;
                                color: #050F0F;
                                font-weight: bold;
                            }

                            .right {
                                width: 80px;
                                height: 24px;
                                line-height: 24px;
                                text-align: center;
                                border-radius: 4px;
                                background: rgba(65,180,140,.2);
                                font-size: 13px;
                                color: #41B48C;
                            }
                        }

                        .content {
                            font-size: 14px;
                            line-height: 24px;
                            color: #829191;
                            font-weight: 500;
                            margin: 20px 0 22px;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }

                        .time {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            font-size: 14px;
                            line-height: 16px;
                            color: #B9C3C3;

                            i {
                                display: block;
                                width: 23px;
                                height: 23px;
                                background: url('../../assets/img/material/clockIcon.svg') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-right: 10px;
                            }
                        }
                    }
                }
             }
         }   
    }
</style>